import type { IEventLeader } from "~/utils/getConsensusDisplay";

import type { ICitationLeader } from "../types";

/** What the Cite sentence quotes from the event's leading outcome. */
export const toCitationLeader = (
  leader: IEventLeader | null | undefined
): ICitationLeader | null =>
  leader
    ? {
        outcome: leader.title,
        chance: leader.chance,
        platformCount: leader.platformCount,
        updatedAt: leader.updatedAt,
      }
    : null;
